import React, { useMemo, useState } from 'react';

import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

import Select from '../../shared/Select';
import Button from '../../shared/Button';
import ModalSelect from '../../shared/modal-select/ModalSelect';

import { targetOptions, rangeOptions } from '../../../constants/setTurnsReporting';

import './styles.scss';

const ConsignmentForm = (props) => {
  const {
    hospitals = [],
    selectedHospitals = [],
    setSelectedHospitals,
    target,
    setTarget,
    range,
    setRange,
    onSubmit,
    loading,
  } = props;

  const [isOpen, toggleModal] = useState(false);

  const hospitalLabel = useMemo(() => {
    if (!selectedHospitals?.length) {
      return 'Select';
    }

    if (selectedHospitals.length === hospitals.length) {
      return 'All hospitals';
    }

    if (selectedHospitals.length === 1) {
      const hospital = hospitals?.find((h) => h.id === selectedHospitals[0]);
      return hospital?.name || '';
    }

    return `${selectedHospitals.length} hospitals selected`;
  }, [selectedHospitals, hospitals]);

  return (
    <div className='set-turns-form__container'>
      <div className='set-turns-form__field'>
        <div>Hospital</div>
        <div className='set-turns-form__select-box' onClick={() => toggleModal(true)}>
          {hospitalLabel}
          <KeyboardArrowDownIcon style={{ fill: '#c6c8c9' }} />
        </div>

        <ModalSelect
          title='Select Hospital'
          listTitle='Hospitals'
          options={hospitals}
          onChange={(value) => setSelectedHospitals(value || [])}
          selected={selectedHospitals}
          onClose={() => toggleModal(false)}
          isOpen={isOpen}
          selectAll
        />
      </div>
      <div className='set-turns-form__field'>
        <div>Performance Target (turns/month)</div>
        <Select
          value={target}
          onChange={setTarget}
          options={targetOptions}
        />
      </div>
      <div className='set-turns-form__field'>
        <div>Date Range</div>
        <Select
          value={range}
          onChange={setRange}
          options={rangeOptions}
        />
      </div>

      <div className='set-turns-form__button'>
        <Button
          onClick={onSubmit}
          disabled={loading || !selectedHospitals.length}
          loading={loading}
          text='Run Report'
        />
      </div>
    </div>
  )
};

export default ConsignmentForm;
